var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sm:mx-5  lg:mx-20%"},[_c('da-patient-create')],1)}
var staticRenderFns = []

export { render, staticRenderFns }